import { STATUS_CLASS_CONFIG, visibleStatusClasses } from '@/config/httpStatus';
import { formatCompactNumber, formatNumber, formatPercent } from '@/utils/format';
import type { StatusClassCounts } from '@/types/stats';
import { StatusClassBar } from './StatusClassBar';
import './stats.css';

export interface StatsTotalsProps {
  requests: number;
  statusClasses: StatusClassCounts;
}

/**
 * Totals row: request count, count and share per status class, and the
 * overall status mix
 */
export function StatsTotals({ requests, statusClasses }: StatsTotalsProps) {
  const classes = visibleStatusClasses(statusClasses);

  return (
    <section className="stats-totals" aria-label="Totals">
      <dl className="stats-tiles">
        <div className="stats-tile">
          <dt className="stats-tile-label">Requests</dt>
          <dd className="stats-tile-value" title={formatNumber(requests)}>
            {formatCompactNumber(requests)}
          </dd>
        </div>
        {classes.map((cls) => (
          <div key={cls} className="stats-tile" data-status-class={cls}>
            <dt className="stats-tile-label">
              <span className={`status-legend-swatch ${STATUS_CLASS_CONFIG[cls].className}`} aria-hidden="true" />
              {STATUS_CLASS_CONFIG[cls].label}
            </dt>
            <dd className="stats-tile-value" title={formatNumber(statusClasses[cls])}>
              {formatCompactNumber(statusClasses[cls])}
              <span className="stats-tile-share">
                {requests > 0 ? formatPercent(statusClasses[cls] / requests) : '-'}
              </span>
            </dd>
          </div>
        ))}
      </dl>
      <StatusClassBar counts={statusClasses} label="All requests by status class" size="lg" />
    </section>
  );
}
